<template>
	<div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
		<feather-icon icon="Edit3Icon" :svgClasses="`h-5 w-5 mr-4 ${!permissionCheck($route.name, 'edit') ? 'cursor-not-allowed opacity-50' : 'hover:text-danger cursor-pointer'}`" @click="updateRolePrompt" />
		<feather-icon icon="UserCheckIcon" :svgClasses="`h-5 w-5 ${!permissionCheck($route.name, 'edit') ? 'cursor-not-allowed opacity-50' : 'hover:text-primary cursor-pointer'}`" @click="confirmStatusChange" />

		<vs-prompt id="role-prompt" title="Update User Role" :is-valid="role['selected'] != null" @cancel="role['selected'] = null" @accept="updateRole" :active.sync="role['prompt']">
			<label class="vs-input--label">Role for "{{ params.data.email }}"</label>
			<div class="con-exemple-prompt text-center">
				<v-select class="w-full" placeholder="Select Role" v-model="role['selected']" :options="rolesMaster" :reset-on-options-change="true" :clearable="false"></v-select>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
	import vSelect from 'vue-select'

	export default {
		name: 'CellRendererActions',
		components: {
			'v-select': vSelect,
		},
		data() {
			return {
				role: {
					selected: null,
					prompt: false
				},
			}
		},
        computed: {
            rolesMaster() {
                return this.$store.state.roles.map(x => {
					return {
						label: x['name'].toLowerCase(),
						value: x['id']
					}
				})
			},
		},
		methods: {
			confirmStatusChange() {
				if(this.permissionCheck(this.$route.name, 'edit')) {
					if (this.params.data.status === 1) {
						this.$vs.dialog({
							type: 'confirm',
							color: 'danger',
							title: 'Confirm Status Change',
							text: `Do you want to deactivate "${this.params.data.email}"?`,
							accept: this.deactivateRecord,
							acceptText: 'Deactivate'
						})
					}
					else {
						this.$vs.dialog({
							type: 'confirm',
							color: 'success',
							title: 'Confirm Status Change',
							text: `Do you want to activate "${this.params.data.email}"?`,
							accept: this.activateRecord,
							acceptText: 'Activate'
						})
					}
				}
			},
			showDeactivateSuccess() {
				this.$vs.notify({
					color: 'success',
					title: 'User deactivated',
					text: 'The selected user was successfully deactivated'
				})
			},
			showActivateSuccess() {
				this.$vs.notify({
					color: 'success',
					title: 'User activated',
					text: 'The selected user was successfully activated'
				})
			},
			deactivateRecord() {
				this.$axiosSecure.patch('/users', {
						'user_id': this.params.data.id,
						'status': 0
					})
					.then(() => {
						this.$root.$emit('refreshPage');

						this.showDeactivateSuccess();
					})
					.catch(error => {
						// Error notification
						if (error.response.status == 401) {
							this.$vs.notify({
								color: 'danger',
								title: `Not authorized`,
								text: `You do not have permission to access the resource`
							});
						}
						else if (error.response.status == 403) {
							// Token invalid so logout
							this.$root.$emit('appLogout');
						}
						else {
							this.$vs.notify({
								color: 'danger',
								title: 'Something went wrong',
								text: 'Please contact the server admin'
							});
						}
						// eslint-disable-next-line no-console
						console.log(error);
					})
			},
			activateRecord() {
				this.$axiosSecure.patch('/users', {
						'user_id': this.params.data.id,
						'status': 1
					})
					.then(() => {
						this.$root.$emit('refreshPage');

						this.showActivateSuccess();
					})
					.catch(error => {
						// Error notification
						if (error.response.status == 401) {
							this.$vs.notify({
								color: 'danger',
								title: `Not authorized`,
								text: `You do not have permission to access the resource`
							});
						}
						else if (error.response.status == 403) {
							// Token invalid so logout
							this.$root.$emit('appLogout');
						}
						else {
							this.$vs.notify({
								color: 'danger',
								title: 'Something went wrong',
								text: 'Please contact the server admin'
							});
						}
						// eslint-disable-next-line no-console
						console.log(error);
					})
			},
			showUpdateRoleSuccess() {
				this.$vs.notify({
					color: 'success',
					title: 'User role updated',
					text: 'The selected user role was successfully updated'
				})
			},
			updateRolePrompt() {
				if(this.permissionCheck(this.$route.name, 'edit')) {
					this.role['prompt'] = true;
				}
			},
			updateRole() {
				this.$axiosSecure.post('/users', {
						'user_id': this.params.data.id,
						'role_id': this.role['selected'] ? this.role['selected']['value'] : null
					})
					.then(() => {
						this.$root.$emit('refreshPage');

						this.showUpdateRoleSuccess();
					})
					.catch(error => {
						// Error notification
						if (error.response.status == 401) {
							this.$vs.notify({
								color: 'danger',
								title: `Not authorized`,
								text: `You do not have permission to access the resource`
							});
						}
						else if (error.response.status == 403) {
							// Token invalid so logout
							this.$root.$emit('appLogout');
						}
						else {
							this.$vs.notify({
								color: 'danger',
								title: 'Something went wrong',
								text: 'Please contact the server admin'
							});
						}
						// eslint-disable-next-line no-console
						console.log(error);
					})
			},
		},
		beforeMount() {
			// Assign current role
			this.role['selected'] = {
				label: this.params.data.acl.role['name'].toLowerCase(),
				value: this.params.data.acl.role['id']
			};
		}
	}
</script>
